"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRoleById = getRoleById;
exports.menuListApi = menuListApi;
var _request = _interopRequireDefault(require("@/utils/request"));
var _verifyCodeCrypto = require("@/utils/verifyCodeCrypto");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// +----------------------------------------------------------------------
// | A2 [ A2赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.A2.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed A2并不是自由软件，未经许可不能去掉A2相关版权
// +----------------------------------------------------------------------
// | Author: A2 Team <admin@A2.com>
// +----------------------------------------------------------------------

/**
 * 角色详情
 */
function getRoleById(pram) {
  return (0, _request.default)({
    url: "/admin/system/role/info/".concat(pram.roles),
    method: 'GET'
  });
}

/**
 * 菜单（与后端 /admin/menuList 对齐，响应为 AES 密文）
 */
function menuListApi() {
  return (0, _request.default)({
    url: '/admin/menuList',
    method: 'GET'
  }).then(function (cipherText) {
    return (0, _verifyCodeCrypto.decryptAesPayload)(cipherText);
  });
}